import React from "react";

const WhatsAppBtn = () => {
  const openWhatsApp = () => {
    const phoneNumber = "919925615191";
    const message =
      "Hi 9R NFC, I want some more information about your services. Please reply soon.";
    const url = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(
      message
    )}`;
    window.open(url, "_blank");
  };

  return (
    <div className="whatsapp-btn">
      <div
        onClick={openWhatsApp}
        className="whatsapp-button d-flex justify-content-center align-items-center border-0 rounded-1 shadow-lg position-relative overflow-hidden"
      >
        <i className="lni lni-whatsapp"></i>
      </div>
    </div>
  );
};

export default WhatsAppBtn;
